export default "__VITE_ASSET__B3PjqBwy__";